export default __webpack_public_path__ + "static/media/1-Mestre-Espedito-Seleiro-Foto-de-Clival-Jr.ea748f9f.jpg";